<div
    #trigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="st-cast-object-item"
    (mouseleave)="onMouseMove($event)"
    (mouseenter)="isPanelOpen = true">
    @switch (data()?.Type) {
        @case (ObjectTypesEnum.TOPIC) {
            <button
                mat-icon-button
                class="st-cast-object-item-fill">
                <mat-icon class="st-cast-object-item-icon">text_snippet</mat-icon>
            </button>
        }
        @default {
            @if (data()) {
                <st-icon
                    hasBorder
                    class="st-cast-object-item-icon-assignment"
                    [type]="assignmentIconType()"
                    [data]="assignment()" />
            }
        }
    }
    <div class="st-cast-object-item-content">
        <div class="st-cast-object-item-content__title">{{ data().Title }}</div>
        <div class="st-cast-object-item-content__subtitle">{{ getItemCreator() }}</div>
    </div>
</div>
@if (!isLast()) {
    <mat-divider class="st-cast-object-item-divider" />
}
<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isPanelOpen"
    [cdkConnectedOverlayPositions]="connectedPositions"
    (attach)="panelAttached()">
    <div class="st-cast-object-item-container-overlay">
        <div class="st-cast-object-item-container-overlay--top-row">
            @if (data()?.Type === ObjectTypesEnum.TOPIC) {
                <st-topic-type
                    mat-chip-grid
                    class="st-cast-object-item-container-overlay__topic-type"
                    [itemList]="globalTablesService.getListItemsForField(PSTFieldNames.PSTTopicType)"
                    [record]="data()"
                    [value]="data()[PSTFieldNames.PSTTopicType]" />
            } @else if (data()?.Type === ObjectTypesEnum.ASSIGNMENT) {
                <st-assignment-type
                    class="st-cast-object-item-container-overlay__topic-type"
                    showLabel
                    showIcon="false"
                    [data]="data()"
                    [value]="assigmentType()" />
            }
            <div
                class="st-cast-object-item-container-overlay--status"
                [matTooltip]="status()?.id">
                {{ status()?.title }}
            </div>
        </div>
        <div class="st-cast-object-item-container-overlay--title">{{ data()?.Title }}</div>
        <st-text-area-overlay
            class="st-cast-object-item-container-overlay--desc"
            minRows="1"
            minHeight="1rem"
            [disabled]="true"
            [value]="data()?.Description"
            [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.Description].DefaultCaption" />
        <div class="st-cast-object-item-container-overlay__owner">
            <span class="st-cast-object-item-container-overlay__owner--label">{{ ownersLabel() }}</span>
            <div class="st-cast-object-item-container-overlay__owner--item">
                @for (owner of owners(); track owner) {
                    <mat-basic-chip>
                        <st-avatar
                            small
                            matChipAvatar
                            [userId]="owner" />
                        {{ owner | titlecase }}
                    </mat-basic-chip>
                }
            </div>
        </div>
        @if (desk()?.length > 0) {
            <div class="st-cast-object-item-container-overlay__desk">
                <span class="st-cast-object-item-container-overlay__desk--label">{{ languageSettings().PSTWebDesksLabel }}</span>
                <div class="st-cast-object-item-container-overlay__desk--item">
                    @for (item of desk(); track item) {
                        <mat-basic-chip>
                            {{ item }}
                        </mat-basic-chip>
                    }
                </div>
            </div>
        }

        <div class="st-cast-object-item-container-overlay__date-time">
            <span class="st-cast-object-item-container-overlay__date-time--label">{{ globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption }}</span>
            <div class="st-cast-object-item-container-overlay__date-time--item">
                <mat-icon class="material-symbols-outlined">today</mat-icon>
                {{ getItemString(PSTFieldNames?.TargetPublicationDate, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString()) }}
            </div>
        </div>
        @if (viewStateCustomItems()?.length > 0) {
            <div class="st-cast-object-item-container">
                @for (idx of [0, 1, 2, 3]; track idx) {
                    <div class="st-topic-item-container-item">
                        @if (viewStateCustomItems()[idx]) {
                            <ng-container
                                [ngTemplateOutlet]="customField"
                                [ngTemplateOutletContext]="{ item: viewStateCustomItems()[idx], data: data, validation: viewStateCustomItems()[idx].Validation?.toUpperCase() }" />
                        }
                    </div>
                }
            </div>
        }
        <ng-template
            #customField
            let-item="item"
            let-data="data"
            let-validation="validation">
            @switch (validation) {
                @case (FieldDefValidations.LOOKUPLIST) {
                    @if (data()?.[item.ID]?.length > 0) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label">{{ item.DefaultCaption }}</span>
                            <mat-chip-listbox class="st-cast-object-item-container-overlay__custom-fields--item">
                                @for (item of data()?.[item.ID]; track item) {
                                    <mat-basic-chip>
                                        {{ item.displayText }}
                                    </mat-basic-chip>
                                }
                            </mat-chip-listbox>
                        </div>
                    }
                }
                @case (FieldDefValidations.TEXT) {
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label">{{ item.DefaultCaption }}</span>
                            <st-text-area-overlay
                                class="st-cast-object-item-container-overlay__custom-fields--text-item"
                                minRows="1"
                                minHeight="1rem"
                                [disabled]="true"
                                [value]="data()?.[item.ID]"
                                [placeholder]="item.DefaultCaption" />
                        </div>
                    }
                }
                @case (FieldDefValidations.COMBOBOX) {
                    @if (data()?.[item.ID]?.length > 0) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label">{{ item.DefaultCaption }}</span>
                            <div class="st-cast-object-item-container-overlay__custom-fields--item">
                                @for (item of data()?.[item.ID]; track item) {
                                    <mat-basic-chip>
                                        {{ item }}
                                    </mat-basic-chip>
                                }
                            </div>
                        </div>
                    }
                }
                @case (FieldDefValidations.CHECKLIST) {
                    @if (data()?.[item.ID]?.length > 0) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label">{{ item.DefaultCaption }}</span>
                            <div class="st-cast-object-item-container-overlay__custom-fields--item">
                                @for (item of data()?.[item.ID]; track item) {
                                    <mat-basic-chip>
                                        {{ item }}
                                    </mat-basic-chip>
                                }
                            </div>
                        </div>
                    }
                }
                @case (FieldDefValidations.CHECKBOX) {
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label">{{ item.DefaultCaption }}</span>
                            <st-check-box
                                class="st-cast-object-item-container-overlay__custom-fields--value"
                                label="APTopStory"
                                [disabled]="true"
                                [contentEditable]="false"
                                [value]="data()?.[item.ID]" />
                        </div>
                    }
                }
                @case (FieldDefValidations.STAFFIDLIST) {
                    @if (data()?.[item.ID]?.length > 0) {
                        <div class="st-cast-object-item-container-overlay__owner">
                            <span class="st-cast-object-item-container-overlay__owner--label">{{ item.DefaultCaption }}</span>
                            <div class="st-cast-object-item-container-overlay__owner--item">
                                @for (owner of data()?.[item.ID]; track owner) {
                                    <mat-basic-chip>
                                        <st-avatar
                                            small
                                            matChipAvatar
                                            [userId]="owner" />
                                        {{ owner | titlecase }}
                                    </mat-basic-chip>
                                }
                            </div>
                        </div>
                    }
                }
                @case (FieldDefValidations.TREE) {
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label">{{ item.DefaultCaption }}</span>
                            <div class="st-cast-object-item-container-overlay__custom-fields--text-item">
                                {{ getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString()) }}
                            </div>
                        </div>
                    }
                }
                @case (FieldDefValidations.ADDRESS) {
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label">{{ item.DefaultCaption }}</span>
                            <div class="st-cast-object-item-container-overlay__custom-fields--text-item">
                                <st-text-area-overlay
                                    class="st-cast-object-item-container-overlay__custom-fields--text-item"
                                    minRows="1"
                                    minHeight="1rem"
                                    [disabled]="true"
                                    [value]="getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString())"
                                    [placeholder]="item.DefaultCaption" />
                            </div>
                        </div>
                    }
                }
                @case (FieldDefValidations.DATETIMERANGE) {
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__date-time">
                            <span class="st-cast-object-item-container-overlay__date-time--label">{{ item.DefaultCaption }}</span>
                            <div class="st-cast-object-item-container-overlay__date-time--item">
                                <mat-icon class="material-symbols-outlined">today</mat-icon>
                                {{ getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString()) }}
                            </div>
                        </div>
                    }
                }
                @case (FieldDefValidations.DATE) {
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__date-time">
                            <span class="st-cast-object-item-container-overlay__date-time--label">{{ item.DefaultCaption }}</span>
                            <div class="st-cast-object-item-container-overlay__date-time--item">
                                <mat-icon class="material-symbols-outlined">today</mat-icon>
                                {{ getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString()) }}
                            </div>
                        </div>
                    }
                }
                @default {
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__date-time">
                            <span class="st-cast-object-item-container-overlay__date-time--label">{{ item.DefaultCaption }}</span>
                            <div class="st-cast-object-item-container-overlay__date-time--item">
                                <mat-icon class="material-symbols-outlined">today</mat-icon>
                                {{ getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString()) }}
                            </div>
                        </div>
                    }
                }
            }
        </ng-template>

        <button
            mat-button
            class="st-cast-object-item-container-overlay__button--approve"
            st-click-stop-propagation
            [class.st-cast-object-item-container-overlay__button--approve--active]="!data()?.PSTApproved"
            (click)="updateTopic(!data().PSTApproved, PSTFieldNames.PSTApproved)">
            @if (data()?.PSTApproved) {
                <mat-icon>done</mat-icon>
            }
            {{ approvedLabel() }}
        </button>

        <button
            mat-button
            color="primary"
            class="st-cast-object-item-container-overlay__button--open"
            (click)="itemClick.emit(data())">
            {{ languageSettings().PSTWebCastObjectsOpenButton }}
        </button>
    </div>
</ng-template>
